var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ConvenientConstants, CriteriaTokenType, DataTokenType, } from '../../../types';
import dtoToCriteria from './dtoToCriteria';
import dtoToLengthControl from './dtoToLengthControl';
export function constantToToken(token) {
    if (token.value === ConvenientConstants[DataTokenType.NEWLINE]) {
        return { type: DataTokenType.NEWLINE };
    }
    else if (token.value === ConvenientConstants[DataTokenType.NEWLINE_MICROSOFT]) {
        return { type: DataTokenType.NEWLINE_MICROSOFT };
    }
    else if (token.value === ConvenientConstants[DataTokenType.TAB]) {
        return { type: DataTokenType.TAB };
    }
    else if (token.value === ConvenientConstants[DataTokenType.COMMA]) {
        return { type: DataTokenType.COMMA };
    }
    else if (/^ +$/.test(token.value)) {
        return {
            type: DataTokenType.SPACE,
            repeat: token.value.length.toString(),
        };
    }
    else {
        return { type: DataTokenType.ARBITRARY_TEXT, text: token.value };
    }
}
export function aggregateToToken(token) {
    if (token.value === CriteriaTokenType.NUM_ROWS) {
        return {
            type: DataTokenType.AGGREGATE_COUNT,
            lengthControl: dtoToLengthControl(token.lengthControl),
        };
    }
    else {
        return {
            type: DataTokenType.AGGREGATE_TOTAL,
            decimal: token.decimal,
            lengthControl: dtoToLengthControl(token.lengthControl),
        };
    }
}
export function dtoToDataToken(token, feeFineTypes, locations, stripes, intl) {
    switch (token.type) {
        case 'Constant':
            return constantToToken(token);
        case 'Aggregate':
            return aggregateToToken(token);
        case 'CurrentDate':
            return {
                type: DataTokenType.CURRENT_DATE,
                format: token.value,
                timezone: token.timezone,
                lengthControl: dtoToLengthControl(token.lengthControl),
            };
        case 'FeeAmount':
            return {
                type: DataTokenType.ACCOUNT_AMOUNT,
                decimal: token.decimal,
                lengthControl: dtoToLengthControl(token.lengthControl),
            };
        case 'FeeDate':
            return {
                type: DataTokenType.ACCOUNT_DATE,
                format: token.value,
                timezone: token.timezone,
                placeholder: token.placeholder,
                dateProperty: token.property,
                lengthControl: dtoToLengthControl(token.lengthControl),
            };
        case 'FeeMetadata':
            return {
                type: DataTokenType.FEE_FINE_TYPE,
                feeFineAttribute: token.value,
                lengthControl: dtoToLengthControl(token.lengthControl),
            };
        case 'ItemData':
            return {
                type: DataTokenType.ITEM_INFO,
                itemAttribute: token.value,
                placeholder: token.placeholder,
                lengthControl: dtoToLengthControl(token.lengthControl),
            };
        case 'UserData':
            return {
                type: DataTokenType.USER_DATA,
                userAttribute: token.value,
                lengthControl: dtoToLengthControl(token.lengthControl),
            };
        case 'UserDataOptional':
            return {
                type: DataTokenType.USER_DATA,
                userAttribute: token.value,
                placeholder: token.placeholder,
                lengthControl: dtoToLengthControl(token.lengthControl),
            };
        case 'Conditional':
        default: {
            var curConditions = Array.isArray(token.conditions) ?
                token.conditions.map(function (condition) { return (__assign(__assign({}, dtoToCriteria(condition.condition, feeFineTypes, locations, stripes, intl)), { value: condition.value.value })); }) : [];
            return {
                type: DataTokenType.CONSTANT_CONDITIONAL,
                conditions: curConditions,
                else: token.else.value,
            };
        }
    }
}
// inverse of ../to/dataToDto
export default function dtoToData(tokens, feeFineTypes, locations, stripes, intl) {
    if (!tokens) {
        return [];
    }
    return tokens.map(function (token) { return dtoToDataToken(token, feeFineTypes, locations, stripes, intl); });
}
